'use client';

import { Button } from '@/components/ui/button';

interface AddToCartButtonProps {
  totalPrice: number;
  onAddToCart: () => void;
  disabled?: boolean;
}

export default function AddToCartButton({ totalPrice, onAddToCart, disabled = false }: AddToCartButtonProps) {
  return (
    <div className="fixed bottom-0 left-1/2 transform -translate-x-1/2 w-full bg-gradient-to-t from-white via-white to-transparent pt-6 pb-6">
      <div className="px-5">
        <Button
          onClick={onAddToCart}
          disabled={disabled}
          className={`w-full font-semibold text-base h-auto py-5 rounded-lg flex items-center justify-center ${
            disabled ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600 text-white'
          }`}
        >
          <div className="flex items-center gap-1">
            {disabled ? (
              <span>품절</span>
            ) : (
              <>
                <span>{totalPrice.toLocaleString()}</span>
                <span>원 담기</span>
              </>
            )}
          </div>
        </Button>
      </div>
    </div>
  );
}
